import { Mail, Users } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { cn } from '../lib/utils';
import { useSettingsStore } from '../state/useSettingsStore';
import TelmePhones from './TelmePhones';

interface ContactInfoProps {
  className?: string;
}

const ContactInfo = ({ className }: ContactInfoProps) => {
  const { t } = useTranslation();
  const email = useSettingsStore(s => s.settings.email);

  return (
    <div className={cn('flex flex-col gap-6', className)}>
      <div>
        <p className="text-base font-extrabold">{t('title')}</p>
        <div className="mt-1 flex flex-col gap-1 text-sm">
          <span>Calle 48 (ex Estrada) N° 1327 (1650)</span>
          <span>Villa Maipú, San Martín</span>
          <span>Provincia de Buenos Aires</span>
          <span>Argentina</span>
        </div>
      </div>
      <div>
        <p className="text-sm font-extrabold">{t('contactUs.customerService')}</p>
        <div className="mt-1 flex flex-col gap-1 text-sm">
          <div className="flex items-center gap-1">
            <Mail size={16} />
            <Link to={`mailto:${email}`} target="_blank" className="hover:underline">
              {email}
            </Link>
          </div>
          <TelmePhones />
          <div className="flex items-center gap-1">
            <Users size={16} />
            <span>Lunes a Viernes de 9:00 a 12:00hs y de 13:00 a 18:00.</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
